import { defineMessages } from 'react-intl'

export const createWLANSaveTemplateMessages = defineMessages({
  saveInstructions: {
    id: 'createWLANSaveTemplateMessages.saveInstructions',
    description: 'Save instructions for template',
    defaultMessage: 'Save configured WLANs as template.',
  },
  enterName: {
    id: 'createWLANSaveTemplateMessages.enterName',
    description: 'Enter name instructions',
    defaultMessage: 'Enter name for this Template',
  },
  errorName: {
    id: 'createWLANSaveTemplateMessages.errorName',
    description: 'Error message for duplicate name',
    defaultMessage:
      'Template with same name already exist. Please use unique name',
  },
})
